import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
// import { Link as RRLink } from 'react-router-dom';
// import { SanitizeHtml } from '@bd/bdcore-utilities';

import { colors } from '../../styles';
import Form from '../../components/Forms/Form';
import { H2Underdog } from '../../helpers/UIElements';

const styles = css`
  padding: 5em 0;
  .Button_wrapper {
    margin-bottom: 0;
  }
  .LeadCapture_title {
    font-weight: 300;
    font-size: 46px;
    color: ${colors.black};
    letter-spacing: 1.12px;
    line-height: 36px;
    @media(min-width: 992px) {
      font-size: 54px;
      letter-spacing: 1.38px;
      line-height: 46px;
    }
  }
  .LeadCapture_subtitle {
    font-weight: 700;
    font-size: 17px;
    color: ${colors.color1};
    letter-spacing: 2.25px;
    text-transform: uppercase;
    margin-bottom: 5em;
    @media(min-width: 992px) {
      font-size: 22px;
      letter-spacing: 2.85px;
    }
  }
`;

function LeadCapture({ content, widget }) {
  return (
    <div className={styles}>
      <div className="LeadCapture_wrapper" />
      <div className="container">
        <div className="col-lg-12 px-4">
          <h1 className="LeadCapture_title">{get(widget, 'title')}</h1>
          <H2Underdog className="LeadCapture_subtitle mt-3 mt-lg-4">{get(widget, 'subtitle')}</H2Underdog>
          <Form
            formName="contactUsModals"
            formLabel="Contact Us Modal"
            thankYou={get(content, 'thank_you_body')}
            fields={[
              {
                type: 'Text',
                label: 'First Name',
                className: 'form-col',
                field: 'firstName',
                required: true,
              },
              {
                type: 'Text',
                label: 'Last Name',
                className: 'form-col',
                field: 'lastName',
                required: true,
              },
              {
                type: 'Email',
                label: 'Email',
                className: 'form-col',
                field: 'email',
                required: true,
                requiredMessage: '',
                invalidMessage: '',
              },
              {
                type: 'Phone',
                label: 'Phone',
                className: 'form-col',
                field: 'phone',
                required: true,
                requiredMessage: '',
                invalidMessage: '',
              },
              {
                type: 'TextArea',
                label: 'Comments/Questions',
                className: 'form-col-fluid',
                placeholder: 'How can we help you?',
                field: 'comments',
                required: false,
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}

LeadCapture.propTypes = {
  content: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default withData({
  widget: 'contact_modal',
})(LeadCapture);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/LeadCapture.js